import * as React from 'react';
import NvPageLengthSelector from './NvPageLengthSelector.esm.js';
import NvPaginationNavigator from './NvPaginationNavigator.esm.js';
import { NvPaginationContext } from './useNvPagination.hooks.esm.js';

// this component relies on context - it must be placed in the DOM hierarchy
// as a descendant of PaginationContextProvider, ex: <PaginationContextProvider value={pagination}>
// where value={pagination} is the value returned from the usePagination hook
var NvPagination = function (_a) {
    var _b = _a.hideNumPerPage, hideNumPerPage = _b === void 0 ? false : _b;
    var numPages = React.useContext(NvPaginationContext).numPages;
    if (!numPages || numPages === 0)
        return null;
    return (React.createElement("div", { className: "nv-pagination", "data-testid": "pagination" },
        !hideNumPerPage && React.createElement(NvPageLengthSelector, { className: "nv-pagination-page-length" }),
        React.createElement(NvPaginationNavigator, { className: "nv-pagination-navigator" })));
};

export { NvPagination as default };
//# sourceMappingURL=NvPagination.esm.js.map
